import { lazyGetAndUpdateRefreshToken } from 'owa-headers-refresh-token';
import { getOWAConnectedAccount } from 'owa-accounts-store';
import { isPastTime } from 'owa-observable-datetime';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { logUsage } from 'owa-analytics';

const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';
const HEADER_AUTHORIZATION: string = 'Authorization';
const HEADER_WEBSESSION_TYPE: string = 'X-OwaWebSessionType';

export async function getConnectedAccountHeaders(
    primarySmtpAddress: string
): Promise<{ [headerName: string]: string }> {
    const headers: { [headerName: string]: string } = {};
    const account = getOWAConnectedAccount(primarySmtpAddress);

    if (account) {
        let token = account.token;

        headers[HEADER_ANCHOR_MAILBOX] = account.anchorMailbox;
        let isExpired = isPastTime(account.tokenExpiry);
        if (!token) {
            // We should always get a token, so log if we don't have a valid account token
            logUsage('[getConnectedAccountHeaders] Invalid account token');
        }

        if (isExpired || !token) {
            token = await lazyGetAndUpdateRefreshToken.importAndExecute(
                account.accountId,
                primarySmtpAddress
            );

            if (!token) {
                // The account is already being marked as invalid in getAndUpdateRefreshToken, but the caller doesn't know about it,
                // so we will set a fake token as a token header to fail the request and log it
                token = '';
                logUsage('[getConnectedAccountHeaders] Token refresh failed');
            }
        }

        let tokenString: string;
        if (account.accountProviderType == 'Outlook') {
            tokenString = `MSAuth1.0 usertoken="${token}", type="MSACT"`;
            headers[HEADER_WEBSESSION_TYPE] = WebSessionType.ExoConsumer.toString();
        } else if (account.accountProviderType == 'Google') {
            tokenString = `Bearer ${token}`;
            headers[HEADER_WEBSESSION_TYPE] = WebSessionType.GMail.toString();
        }

        headers[HEADER_AUTHORIZATION] = tokenString;
    }

    return headers;
}
